export enum FundingSourceStatus {
  VERIFIED = 'VERIFIED',
  UNVERIFIED = 'UNVERIFIED'
}
